module.exports = __webpack_public_path__ + "img/woman_tipping_hand.2d656a13.gif";